// extracted by mini-css-extract-plugin
export default {"touchBtn":"HiddenTopBar_touchBtn__Ep-h9","slide":"HiddenTopBar_slide__ZMBlG","box":"HiddenTopBar_box__Tsr3s"};